import React from 'react'
import PropTypes from 'prop-types'
import ReactSVG from 'react-svg'
import { useRouter } from 'next/router'
import useTranslation from 'next-translate/useTranslation'

import translations from '../../../../../../../public/data/translations.json'

export const Buttons = ({
	width,
	height,
	diameter,
	season,
	tipVozila,
	manufacturer,
	setWidth,
	setHeight,
	setDiameter,
	setSeason,
	setTipVozila,
	setManufacturer,
	isSubmitting,
	isFieldsLoading,
	submit
}) => {
	const { t, lang } = useTranslation('common')

	const locale = lang?.toUpperCase() || 'ME'

	const isDisabled = isSubmitting || isFieldsLoading

	const router = useRouter()

	return (
		<div className='filter-buttons'>
			<button
				className={`filter-buttons-search`}
				onClick={() => {
					router.push({ pathname: '/vehicleParts' }, `/${translations.noviDjeloviUrl[locale]}/${translations['auto-djelovi'][locale].gume.slug}`)
				}}
			>
				<ReactSVG
					src='/icons/161.obrisati.svg'
					beforeInjection={svg => {
						svg.setAttribute('style', 'width: 15px; height: auto; margin-right: 7px; margin-top: 3px;')
					}}
					className='pretraga-reset-filter'
				/>
				<span style={{ textTransform: 'uppercase' }}>{t('resetSearchVehiclePartsText')}</span>
			</button>

			<button
				className={`filter-buttons-search${isDisabled ? ' disabled' : ''}`}
				onClick={!isDisabled ? () => {
					const values = {}

					if (Number(width) && Number(width) !== -1) values.width = width
					if (Number(height) && Number(height) !== -1) values.height = height
					if (Number(diameter) && Number(diameter) !== -1) values.diameter = diameter
					if (season && Number(season) !== -1) values.season = season
					if (tipVozila && Number(tipVozila) !== -1) values.tire_vehicle_type = tipVozila
					if (manufacturer && Number(manufacturer) !== -1) values.manufacturer = manufacturer

					submit(values)
				} : () => { }}
			>
				<i className='ogl-header-ico ico-pretraga-text-search-lupa ico' />
				<span style={{ textTransform: 'uppercase' }}>{t('Pretraži')}</span>
			</button>
		</div>
	)
}

Buttons.propTypes = {
	width: PropTypes.string,
	height: PropTypes.string,
	diameter: PropTypes.string,
	season: PropTypes.string,
	tire_vehicle_type: PropTypes.string,
	manufacturer: PropTypes.string,
	setWidth: PropTypes.func.isRequired,
	setHeight: PropTypes.func.isRequired,
	setDiameter: PropTypes.func.isRequired,
	setSeason: PropTypes.func.isRequired,
	setTipVozila: PropTypes.func.isRequired,
	setManufacturer: PropTypes.func.isRequired,
	isFieldsLoading: PropTypes.bool.isRequired,
	isSubmitting: PropTypes.bool.isRequired,
	submit: PropTypes.func.isRequired,
	filteredFields: PropTypes.shape({
    data: PropTypes.shape({
      width: PropTypes.arrayOf(PropTypes.shape({
				name: PropTypes.string.isRequired,
				slug: PropTypes.string.isRequired,
			})),
			height: PropTypes.arrayOf(PropTypes.shape({
				name: PropTypes.string.isRequired,
				slug: PropTypes.string.isRequired,
			})),
			diameter: PropTypes.arrayOf(PropTypes.shape({
				name: PropTypes.string.isRequired,
				slug: PropTypes.string.isRequired,
			})),
			manufacturer: PropTypes.arrayOf(PropTypes.shape({
				name: PropTypes.string.isRequired,
				slug: PropTypes.string.isRequired
			})),
			season: PropTypes.arrayOf(PropTypes.shape({
				name: PropTypes.string.isRequired,
				slug: PropTypes.string.isRequired
			})),
			tire_vehicle_type: PropTypes.arrayOf(PropTypes.shape({
				name: PropTypes.string.isRequired,
				slug: PropTypes.string.isRequired,
				image_path: PropTypes.string.isRequired
			}))
    })
  }).isRequired,
}
